export const arcticsunrise = {
  name: 'Arctic Sunrise',
  color: [0.43137254901960786, 0.7098039215686275, 0.7529411764705882, 1],
  bg: [1, 0.8, 0.7333333333333333, 1],
  grid1: [0, 0.4235294117647059, 0.5176470588235295, 1],
  grid2: [0.8862745098039215, 0.9098039215686274, 0.8941176470588236, 1],
}
